import type { Module } from 'vuex';

export const namespace = 'userAuth';

export interface ITokensParams {
	sessionToken?: string;
	authToken?: string;
}

export interface IAuthStore {
	sessionToken: string | null;
	authToken: string | null;
}

export const MutationType = {
	SET_SESSION_TOKEN: 'SET_SESSION_TOKEN',
	UNSET_TOKENS: 'UNSET_TOKENS',
	SET_TOKENS: 'SET_TOKENS',
};

export const actionType = {
	SET_TOKEN: 'setToken',
	SET_SESSION_TOKEN: 'SET_SESSION_TOKEN',
	SET_TOKENS: 'SET_TOKENS',
	UNSET_TOKENS: 'UNSET_TOKENS',
};

export default function authStore(): Module<IAuthStore, any> {
	return {
		namespaced: true,
		state: () => ({
			sessionToken: null,
			authToken: null,
		}),
		actions: {
			[actionType.SET_TOKEN](state, tokens: ITokensParams): void {
				this.$api.auth = tokens;
				this.$api.locale = this.$api?.userLocale || this.$api?.configProps?.headers?.['x-user-locale'] || "";
			},
			[actionType.SET_TOKENS]({ commit }, tokens: ITokensParams): void {
				commit(MutationType.SET_TOKENS, tokens);
			},
			[actionType.SET_SESSION_TOKEN]({ commit }, sessionToken): void {
				commit(MutationType.SET_SESSION_TOKEN, sessionToken);

				this.$api.auth = {
					sessionToken: sessionToken,
					authToken: this.$api?.authToken || ''
				};
				this.$api.locale = this.$api?.userLocale || this.$api?.configProps?.headers?.['x-user-locale'] || "";
			},
			[actionType.UNSET_TOKENS]({ commit }): void {
				commit(MutationType.UNSET_TOKENS);
			},
		},
		mutations: {
			[MutationType.SET_SESSION_TOKEN]: (state, sessionToken: string) => {
				state.sessionToken = sessionToken;
			},
			[MutationType.SET_TOKENS]: (state, { sessionToken, authToken }: ITokensParams) => {
				if (sessionToken) {
					state.sessionToken = sessionToken;
				}
				if (authToken) {
					state.authToken = authToken;
				}
			},
			[MutationType.UNSET_TOKENS]: (state) => {
				state.sessionToken = null;
				state.authToken = null;
			},
		},
		getters: {
			sessionToken: ({ sessionToken }): string | null => sessionToken,
			authToken: ({ authToken }): string | null => authToken,
		},
	};
}
